import SearchIcon from "assets/icons/search.svg?react";
import InputWithIcon from "components/shared/InputWithIcon";
import React, { FC } from "react";
import t from "utils/i18n";

interface Props {
  searchText: string;
  onSearchChange: (text: string) => void;
}

const SearchBar: FC<Props> = ({ searchText, onSearchChange }) => {
  return (
    <div className="flex items-center justify-center bg-white">
      <InputWithIcon
        type="text"
        label=""
        id="searchbar"
        placeholder={t("sidebar.searchPlaceholder")}
        value={searchText}
        onChange={(e) => onSearchChange(e.target.value)}
        iconPosition="left"
        icon={<SearchIcon />}
      />
    </div>
  );
};

export default SearchBar;
